import React, { useState } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import SRC_Trans_Details from './SRC_Trans_Details';

const SRC_Trans_Int = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); // Manage loading state
    const [value, setValue] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value.toUpperCase();

        // Allow only alphabets and numbers
        if (/^[A-Z0-9]*$/.test(inputValue)) {
            if (inputValue.length <= 25) {
                setValue(inputValue);
            }
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (pasteData.length <= 25) {
            setValue(pasteData);
        }
        e.preventDefault(); // Prevent default pasting behavior
    };

    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const rc_no = document.getElementById('rc_no').value;

        if (month == 0 || month == null || month == '') {
            alert('Please select Month');
        } else if (year == 0 || year == null || year == '') {
            alert('Please select Year');
        } else if (rc_no.length == 0 || rc_no == null || rc_no.trim() == '') {
            alert('Please Enter SRC No');
        } else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <SRC_Trans_Details
                        month={month}
                        year={year}
                        src_no={rc_no}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleLoadingChange} /></td>
                                    <td>RC No:</td>
                                    <td><input type="text" placeholder="Enter RC Number"
                                        onmouseover="this.select()" maxlength="25"
                                        name="rc_no" id="rc_no"
                                        value={value}
                                        onChange={handleInputChange}
                                        onPaste={handlePaste} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default SRC_Trans_Int;








